import React from 'react'
import PropTypes from 'prop-types'
import LinkColumn from './link-column'
import AccordionLink from './accordion-link'
import {Box, Divider, SimpleGrid, useMultiStyleConfig} from '@chakra-ui/react'

const StandardLinks = ({linkGroupSchema}) => {
    const styles = useMultiStyleConfig('Footer')

    return (
        <>
            <Box w="100%" {...styles.hideOnMobile}>
                <Divider {...styles.dividerRule} {...styles.kenwoodDividerRule} />
                <SimpleGrid columns={5} {...styles.linkColumnContainer} data-testid="link-column">
                    <LinkColumn variant={'vertical'} linkGroupSchema={linkGroupSchema} />
                </SimpleGrid>
            </Box>
            <Box w="100%" {...styles.hideOnDesktop} data-testid="accordion-link">
                <AccordionLink linkGroupSchema={linkGroupSchema} />
            </Box>
        </>
    )
}

StandardLinks.propTypes = {
    linkGroupSchema: PropTypes.array.isRequired,
}
export default StandardLinks
